import { Typography } from '@mui/material'

export const AdminOrders = (): JSX.Element => {
  return (
    <Typography variant="h5" color="secondary.main">
      Assinaturas
    </Typography>
  )
}
